export default "__VITE_ASSET__NyEGamqg__"